import { render, staticRenderFns } from "./SettingsAccountSection.vue?vue&type=template&id=0be80198&scoped=true"
import script from "./SettingsAccountSection.vue?vue&type=script&lang=js"
export * from "./SettingsAccountSection.vue?vue&type=script&lang=js"
import style0 from "./SettingsAccountSection.vue?vue&type=style&index=0&id=0be80198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be80198",
  null
  
)

export default component.exports